// Harga grosir bertingkat per produk per cabang. Aturan SAMA dengan server (backend utils/hargaGrosir.js) dan aplikasi HP:
//  - harga grosir berlaku untuk SEMUA unit produk itu begitu jumlahnya mencapai batas (bukan bertahap);
//  - jumlah = total unit produk yang sama di keranjang (beberapa baris dengan opsi berbeda dijumlah);
//  - tingkat dipilih yang batasnya terbesar yang tercapai; harga tingkat yang tidak lebih murah dari harga biasa diabaikan;
//  - harga tambahan opsi/topping tetap ditambahkan di atas harga satuan; promo dihitung dari harga yang sudah grosir.
export const MAKS_TINGKAT = 5;
const bulat2 = (v) => Math.round((Number(v) || 0) * 100) / 100;

/** Daftar tingkat dari server -> [{ min, harga }] urut `min` naik; selalu array. */
export const bacaTingkat = (mentah) => {
  let x = mentah;
  if (typeof x === 'string') {
    try { x = JSON.parse(x); } catch { return []; }
  }
  if (!Array.isArray(x)) return [];
  return x
    .map((t) => ({ min: Math.floor(Number(t && t.min)), harga: bulat2(t && t.harga) }))
    .filter((t) => t.min >= 2 && t.harga > 0)
    .sort((a, b) => a.min - b.min);
};

/** Harga satuan dasar (tanpa opsi) untuk `jumlah` unit. */
export const hargaGrosirUntuk = (hargaDasar, tingkat, jumlah) => {
  const dasar = Number(hargaDasar) || 0;
  let harga = dasar;
  for (const t of bacaTingkat(tingkat)) {
    if (jumlah >= t.min && t.harga < dasar && t.harga < harga) harga = t.harga;
  }
  return harga;
};

/** Isian form ([{ min, harga }] berupa teks) -> { tingkat } atau { galat }; kosong = tanpa tingkat. */
export const periksaTingkat = (baris, hargaDasar) => {
  const isi = (baris || []).filter((b) => String(b.min).trim() !== '' || String(b.harga).trim() !== '');
  if (isi.length > MAKS_TINGKAT) return { galat: `Maksimal ${MAKS_TINGKAT} tingkat harga grosir` };
  const hasil = [];
  for (const b of isi) {
    const min = Number(b.min);
    const harga = Number(b.harga);
    if (!Number.isInteger(min) || min < 2) return { galat: 'Jumlah minimal harus bilangan bulat, minimal 2' };
    if (!Number.isFinite(harga) || harga <= 0) return { galat: 'Harga grosir harus lebih dari 0' };
    hasil.push({ min, harga: bulat2(harga) });
  }
  hasil.sort((a, b) => a.min - b.min);
  let sebelumnya = bulat2(hargaDasar);
  for (let i = 0; i < hasil.length; i += 1) {
    if (i > 0 && hasil[i].min === hasil[i - 1].min) return { galat: 'Jumlah minimal tiap tingkat harus berbeda' };
    if (hasil[i].harga >= sebelumnya) return { galat: i === 0 ? 'Harga grosir harus lebih murah dari harga biasa' : 'Harga grosir harus makin murah di jumlah yang lebih besar' };
    sebelumnya = hasil[i].harga;
  }
  return { tingkat: hasil };
};

/** Teks ringkas untuk tabel/kartu produk, mis. "6+ Rp 66.000 • 24+ Rp 63.000"; kosong bila tanpa tingkat. */
export const ringkasGrosir = (tingkat) =>
  bacaTingkat(tingkat).map((t) => `${t.min}+ Rp ${Math.round(t.harga).toLocaleString('id-ID')}`).join(' • ');

/**
 * Harga satuan dasar tiap produk di keranjang menurut jumlah total produk itu.
 * @param {Array<{ id: string, harga: number, hargaGrosir?: any, jumlah: number }>} baris  baris keranjang (produk sama boleh berulang)
 * @returns {Map<string, number>} id produk -> harga satuan dasar
 */
export const hargaDasarKeranjang = (baris) => {
  const jumlah = new Map();
  for (const b of baris) jumlah.set(b.id, (jumlah.get(b.id) || 0) + (Number(b.jumlah) || 0));
  const hasil = new Map();
  for (const b of baris) if (!hasil.has(b.id)) hasil.set(b.id, hargaGrosirUntuk(b.harga, b.hargaGrosir, jumlah.get(b.id)));
  return hasil;
};
